/**
 * formatIstanbulDateTime.js — bir ISO zaman damgasını (UTC ofsetli) Europe/
 * Istanbul yerel duvar saatine çevirip "gg.aa.yyyy SS:dd" (tr) / "dd/mm/yyyy
 * HH:mm" (en) biçiminde döner. Tarayıcının/işletim sisteminin yerel saat
 * dilimi ayarından BAĞIMSIZDIR — `timeZone: 'Europe/Istanbul'` `Intl` API'ye
 * açıkça geçirilir.
 *
 * `fmtDateOnly` (aynı klasör) ile KARIŞTIRILMASIN: o saf "YYYY-MM-DD" (saat
 * bileşeni yok) tarih string'leri içindir. Bu dosya SAAT bileşeni de taşıyan
 * ISO zaman damgaları (ör. `matched_at`, `created_at`) içindir.
 */
export function fmtIstanbulDateTime(dateInput, lang = 'tr') {
  if (!dateInput) return '—';
  const dt = new Date(dateInput);
  if (Number.isNaN(dt.getTime())) return dateInput;
  try {
    const locale = lang === 'tr' ? 'tr-TR' : 'en-GB';
    const datePart = dt.toLocaleDateString(locale, { timeZone: 'Europe/Istanbul' });
    const timePart = dt.toLocaleTimeString(locale, {
      timeZone: 'Europe/Istanbul',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    return `${datePart} ${timePart}`;
  } catch {
    return dateInput;
  }
}

export default fmtIstanbulDateTime;
